function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-13.284 16.7002C190.858 5.36022 395.5 2.35022 600.036 3.11022C803.713 3.87022 1007.35 8.17022 1210.97 11.8902C1325.41 13.9802 1439.84 16.0702 1554.28 18.1602C1556.57 18.2002 1556.57 15.2002 1554.28 15.1602C1349.42 11.4202 1144.57 7.46022 939.704 4.00022C736.182 0.570221 532.564 -1.73978 329.006 1.69022C214.822 3.61022 100.686 7.37022 -13.284 13.7002C-15.5601 13.8302 -15.5839 16.8302 -13.284 16.7002Z",
  fill: "#CFCFCF"
});

var SvgComicSeparator = function SvgComicSeparator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 1540 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComicSeparator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comic-separator.b131be22.svg";
export { ForwardRef as ReactComponent };